var map = {
	"./account-tickets/account-tickets.js": [
		7010,
		7010
	],
	"./account/account.js": [
		5170,
		5170
	],
	"./action-block/action-block.js": [
		4920,
		4920
	],
	"./affiliate/affiliate.js": [
		2314,
		2314
	],
	"./certificates/certificates.js": [
		6740,
		6740
	],
	"./dashboard/dashboard.js": [
		282,
		282
	],
	"./data-processing-agreement/data-processing-agreement.js": [
		2706,
		2706
	],
	"./dedicated-server/dedicated-server.js": [
		3050,
		3050
	],
	"./detail/detail.js": [
		9622,
		9622
	],
	"./dns-table/dns-table.js": [
		4906,
		4906
	],
	"./domain-modals/domain-modals.js": [
		66,
		66
	],
	"./domain-profile/domain-profile.js": [
		8172,
		8172
	],
	"./domains/domains.js": [
		6305,
		3135,
		8686
	],
	"./footer/footer.js": [
		4562,
		4562
	],
	"./header/header.js": [
		1170,
		1170
	],
	"./hosting-packages/hosting-packages.js": [
		8608,
		8608
	],
	"./hosting/hosting.js": [
		9222,
		3135,
		9222
	],
	"./ideas/ideas.js": [
		6782,
		6782
	],
	"./jetpack/jetpack.js": [
		2434,
		2434
	],
	"./knowledgebank-suggestions/knowledgebank-suggestions.js": [
		5342,
		5342
	],
	"./layout/layout.js": [
		6472,
		6472
	],
	"./login/login.js": [
		9974,
		9974
	],
	"./menu-certificates/menu-certificates.js": [
		2046,
		2046
	],
	"./menu-dns/menu-dns.js": [
		634,
		634
	],
	"./menu-domain/menu-domain.js": [
		2350,
		2350
	],
	"./menu-hosting/menu-hosting.js": [
		9832,
		9832
	],
	"./menu-microsoft-365/menu-microsoft-365.js": [
		4466,
		4466
	],
	"./menu-nameserver/menu-nameserver.js": [
		1274,
		1274
	],
	"./menu-profile/menu-profile.js": [
		9154,
		9154
	],
	"./menu-public-cloud/menu-public-cloud.js": [
		5186,
		5186
	],
	"./menu-vps/menu-vps.js": [
		8850,
		8850
	],
	"./microsoft-365/microsoft-365.js": [
		2621,
		5002
	],
	"./migration-request/migration-request.js": [
		7678,
		3135,
		7678
	],
	"./navbar-carousel/navbar-carousel.js": [
		1858,
		9599,
		1858
	],
	"./order/order.js": [
		5306,
		5306
	],
	"./package/package.js": [
		5846,
		5846
	],
	"./phone-input/phone-input.js": [
		9558,
		9558
	],
	"./public-cloud/public-cloud.js": [
		8630,
		8630
	],
	"./reseller/reseller.js": [
		6600,
		6600
	],
	"./search-block/search-block.js": [
		9984,
		9984
	],
	"./shoppingcart/shoppingcart.js": [
		696,
		696
	],
	"./sidebar/sidebar.js": [
		9358,
		9358
	],
	"./specification/specification.js": [
		9290,
		9290
	],
	"./two-factor-prompt/two-factor-prompt.js": [
		7242,
		7242
	],
	"./vps-v1/vps-v1.js": [
		9762,
		9762
	],
	"./vps/vps.js": [
		7098,
		7098
	],
	"./website-builder-installer/website-builder-installer.js": [
		4094,
		4094
	],
	"./wordpress-manager/wordpress-manager.js": [
		950,
		3135,
		950
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 8730;
module.exports = webpackAsyncContext;